<template>
    <section id="navigation" class="shadow my-navigation">
        <div class="inner navigation">
            <div class="logo">
                <a class="scroll" href="/"
                    ><img
                        :src="baseUrl + '/new-assets/images/logo.png?v=13'"
                        alt="EFG Hermes"
                /></a>
            </div>

            <div class="nav-menu">
                <ul class="nav main-nav">
                    <li>
                        <router-link to="./dashboard">Home</router-link>
                    </li>
                    <!-- <li>
                        <router-link to="./information"
                            >Useful Information</router-link
                        >
                    </li> -->
                    <!-- <li>
                        <router-link to="./schedule-preview">Schedule Preview</router-link>
                    </li>
                    <li v-if="!isPresenter">
                        <router-link to="./preferences">Meeting Preferences</router-link>
                    </li> -->
                    <!-- <li>
                        <router-link to="./gallery">Photo Gallery</router-link>
                    </li> -->
                    <li>
                        <a href="mailto:OneOnOne@EFG-HERMES.com"
                            >Contact Us</a
                        >
                    </li>
                </ul>
                <a v-if="isLoggedIn" class="btn btn-primary log" href="#" @click.prevent="logout">
					Logout
				</a>
            </div>

            <div class="dropdown mobile-drop">
                <a data-toggle="dropdown" class="mobile-menu" href="#">
                    <i class="fa fa-bars" />
                </a>
            </div>

        </div>
    </section>
</template>

<script>
export default {
    name: "Navbar",
    data: () => ({
        baseUrl: window.location.origin,
    }),
    computed: {
        // isPresenter() {
        //     return JSON.parse(localStorage.client).client.client_type_id === 4;
        // },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },
    methods: {
        logout() {
            this.$store.dispatch("logout");
            this.$store.dispatch("endRegisrationProccess");
            this.$router.push("/auth/login");
        },
    },
};
</script>

<style lang="scss" scoped>
.logout-link {
    color: #e74c3c;
    &:hover {
        color: #c0392b;
    }
}
a.mobile-menu {
    margin-top: 0.5rem;
}
.my-navigation {
    position: fixed !important;
    top: 0;
}
</style>
